/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerCreateArticleResponse } from './BlogManagerCreateArticleResponse';

export type BlogManagerCreateArticleResponseApiRespoonse = {
    data?: BlogManagerCreateArticleResponse;
    status?: BlogManagerCreateArticleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BlogManagerCreateArticleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

